import { useState, useEffect } from "react";
import { TrendingUp } from "lucide-react";
import { BACKEND_URL } from "../../context/AuthContext";

const AdminLeadsTab = ({ authToken, onMessage }) => {
  const [intents, setIntents] = useState([]);
  const headers = { 'Content-Type': 'application/json', ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}) };

  const fetch_ = async () => {
    try {
      const res = await fetch(`${BACKEND_URL}/api/admin/upgrade-intents`, { headers });
      if (res.ok) { const data = await res.json(); setIntents(data.intents || []); }
    } catch (e) { console.error(e); }
  };

  useEffect(() => { fetch_(); }, []);

  const activate = async (email, planId) => {
    try {
      const res = await fetch(`${BACKEND_URL}/api/admin/upgrade-intents/${encodeURIComponent(email)}/activate?plan=${planId}`, { method: 'PUT', headers });
      if (res.ok) { onMessage(`Upgraded ${email} to ${planId}`); fetch_(); }
    } catch (e) { console.error(e); }
  };

  return (
    <div data-testid="admin-leads-tab">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-bold text-white">Upgrade Leads</h2>
          <p className="text-white/50 text-sm">Listeners who clicked "Start Broadcasting" and viewed payment options</p>
        </div>
        <button onClick={fetch_} className="bg-white/10 hover:bg-white/15 text-white px-4 py-2 rounded-lg text-sm transition">Refresh</button>
      </div>
      {intents.length === 0 ? (
        <div className="bg-white/5 border border-white/10 rounded-xl p-8 text-center">
          <TrendingUp className="w-10 h-10 text-white/20 mx-auto mb-3" />
          <p className="text-white/40">No upgrade leads yet</p>
          <p className="text-white/20 text-sm mt-1">When listeners click "Start Broadcasting", they'll appear here</p>
        </div>
      ) : (
        <div className="space-y-3">
          {intents.map((intent, i) => (
            <div key={i} className={`bg-white/5 border rounded-xl p-4 flex items-center justify-between ${intent.status === 'activated' ? 'border-green-500/30' : 'border-white/10'}`} data-testid={`lead-${i}`}>
              <div className="flex items-center gap-4">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${intent.status === 'activated' ? 'bg-green-500/20' : 'bg-purple-500/20'}`}>
                  <TrendingUp className={`w-5 h-5 ${intent.status === 'activated' ? 'text-green-400' : 'text-purple-400'}`} />
                </div>
                <div><p className="text-white font-medium text-sm">{intent.name || 'Unknown'}</p><p className="text-white/50 text-xs">{intent.email}</p></div>
                <div className="ml-4"><p className="text-purple-400 text-sm font-medium">{intent.plan_name}</p><p className="text-white/40 text-xs">${intent.price}/mo</p></div>
                <div className="ml-4"><p className="text-white/30 text-xs">{intent.created_at ? new Date(intent.created_at).toLocaleString() : ''}</p></div>
              </div>
              <div className="flex items-center gap-2">
                {intent.status === 'activated' ? (
                  <span className="bg-green-500/20 text-green-400 px-3 py-1 rounded-full text-xs font-medium">Activated</span>
                ) : (
                  <button onClick={() => activate(intent.email, intent.plan_id)} className="bg-green-500 hover:bg-green-600 text-white px-4 py-1.5 rounded-lg text-xs font-medium transition" data-testid={`activate-lead-${i}`}>Activate Plan</button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminLeadsTab;
